/* eslint-disable import/prefer-default-export */
import UAEventTracking from 'modules/tracking/UAEventTracking';

export function handleClickTracking(buttonText?: string): void {
    UAEventTracking({
        eventCategory: 'featuredFooter',
        eventAction: 'link',
        eventLabel: buttonText
    });
}
